//  import React, { useState } from "react";

// export default function MerchantAuthWeb() {
//   // Navigation State Between Registration Form & OTP Terminal
//   const [step, setStep] = useState(1); // 1 = Registration, 2 = OTP Verification
//   const [loading, setLoading] = useState(false);

//   // Form Fields State
//   const [formData, setFormData] = useState({
//     ownerName: "",
//     businessName: "",
//     businessType: "",
//     mobile: "",
//     address: ""
//   });

//   // OTP Value State
//   const [otpCode, setOtpCode] = useState("");

//   // Input State Modifier Handlers
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // STEP 1: SUBMIT REGISTRATION VIA FORMDATA
//   const handleRegister = async (e) => {
//     e.preventDefault();
//     const { ownerName, businessName, businessType, mobile, address } = formData;

//     if (!ownerName || !businessName || !businessType || !mobile || !address) {
//       alert("Please fill all fields before proceeding.");
//       return;
//     }

//     setLoading(true);

//     try {
//       // Setting up corporate FormData payload matching your exact specs
//       const dataPayload = new FormData();
//       dataPayload.append("owner_name", ownerName);
//       dataPayload.append("business_name", businessName);
//       dataPayload.append("business_type", businessType);
//       dataPayload.append("mobile", mobile);
//       dataPayload.append("address", address);

//       const requestOptions = {
//         method: "POST",
//         body: dataPayload,
//         redirect: "follow"
//       };

//       const response = await fetch("https://countmyvisit.com/Apis/marchentlogin.php", requestOptions);
//       const resultText = await response.text();
//       console.log("Server Payload Logs:", resultText);

//       // Advance to OTP terminal step
//       setStep(2);
//     } catch (error) {
//       console.error("Transmission Node Exception:", error);
//       alert("Unable to establish contact with the registration authentication gateway.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // STEP 2: VERIFY SUBMITTED OTP FIELD
//   const handleVerifyOTP = async (e) => {
//     e.preventDefault();
//     if (otpCode.length < 4) {
//       alert("Please enter a valid 4-digit security code.");
//       return;
//     }

//     setLoading(true);

//     try {
//       // Creating verification payload bundle via FormData
//       const otpPayload = new FormData();
//       otpPayload.append("mobile", formData.mobile);
//       otpPayload.append("otp_code", otpCode);

//       const requestOptions = {
//         method: "POST",
//         body: otpPayload,
//         redirect: "follow"
//       };

//       // Target your production verification URL route point here
//       const response = await fetch("https://countmyvisit.com/Apis/verify_otp.php", requestOptions);
//       const resultText = await response.text();
//       console.log("Verification Response Logs:", resultText);

//       alert("Success 🎉! Identity cleared. Business Node deployed onto operational mainnet.");
      
//       // Reset full engine architecture flow upon completion
//       setStep(1);
//       setOtpCode("");
//       setFormData({ ownerName: "", businessName: "", businessType: "", mobile: "", address: "" });
//     } catch (error) {
//       console.error("Security Authentication Gateway Fault:", error);
//       alert("The validation script rejected the processed security credentials token.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="auth-web-container">
//       {/* INLINE CORE SCOPED STYLE ARCHITECTURE */}
//       <style>{`
//         .auth-web-container {
//           min-height: 100vh;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: #f8fafc;
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           padding: 20px;
//           box-sizing: border-box;
//         }
//         .auth-card {
//           background: #ffffff;
//           width: 100%;
//           max-width: 480px;
//           border-radius: 16px;
//           border: 1px solid #e2e8f0;
//           box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.05);
//           padding: 40px;
//           box-sizing: border-box;
//         }
//         .brand-header {
//           text-align: center;
//           margin-bottom: 32px;
//         }
//         .brand-logo {
//           font-size: 26px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 0 0 6px 0;
//           letter-spacing: -0.5px;
//         }
//         .brand-tagline {
//           font-size: 14px;
//           color: #64748b;
//           margin: 0;
//         }
//         .form-group {
//           margin-bottom: 20px;
//           display: flex;
//           flex-direction: column;
//           gap: 6px;
//         }
//         .form-group label {
//           font-size: 12px;
//           font-weight: 600;
//           color: #475569;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
//         .form-input {
//           width: 100%;
//           padding: 12px 16px;
//           border-radius: 8px;
//           border: 1px solid #cbd5e1;
//           font-size: 15px;
//           color: #0f172a;
//           background: #f8fafc;
//           outline: none;
//           transition: border-color 0.2s;
//           box-sizing: border-box;
//         }
//         .form-input:focus {
//           border-color: #6366f1;
//           background: #ffffff;
//         }
//         .form-textarea {
//           resize: none;
//           min-height: 70px;
//         }
//         .otp-box-wrapper {
//           display: flex;
//           justify-content: center;
//           margin: 24px 0;
//         }
//         .otp-web-input {
//           width: 180px;
//           font-size: 24px;
//           font-weight: 700;
//           letter-spacing: 12px;
//           text-align: center;
//           padding: 12px;
//           border: 2px dashed #6366f1;
//           border-radius: 10px;
//           background: #f1f5f9;
//           color: #6366f1;
//           outline: none;
//         }
//         .otp-web-input:focus {
//           border-style: solid;
//           background: #ffffff;
//         }
//         .submit-btn-primary {
//           width: 100%;
//           background: #6366f1;
//           color: #ffffff;
//           border: none;
//           padding: 14px;
//           font-size: 15px;
//           font-weight: 600;
//           border-radius: 8px;
//           cursor: pointer;
//           transition: background 0.2s;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//         }
//         .submit-btn-primary:hover {
//           background: #4f46e5;
//         }
//         .submit-btn-primary:disabled {
//           background: #94a3b8;
//           cursor: not-allowed;
//         }
//         .back-nav-link {
//           display: block;
//           text-align: center;
//           margin-top: 20px;
//           font-size: 13px;
//           color: #64748b;
//           text-decoration: none;
//           font-weight: 500;
//           background: none;
//           border: none;
//           width: 100%;
//           cursor: pointer;
//         }
//         .back-nav-link:hover {
//           color: #0f172a;
//         }
//         .context-alert-text {
//           font-size: 14px;
//           color: #475569;
//           text-align: center;
//           line-height: 22px;
//           margin-bottom: 16px;
//         }
//         .spinner {
//           width: 18px;
//           height: 18px;
//           border: 2px solid #ffffff;
//           border-top-color: transparent;
//           border-radius: 50%;
//           animation: spin 0.6s linear infinite;
//         }
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div className="auth-card">
//         {/* BRAND MANAGEMENT TITLE LAYER */}
//         <div className="brand-header">
//           <h2 className="brand-logo">Bazaar Portal</h2>
//           <p className="brand-tagline">
//             {step === 1 ? "Merchant Onboarding Engine" : "Security Verification Gate"}
//           </p>
//         </div>

//         {/* SEQUENCE TERMINAL 1: ACCOUNT PROFILE SETUP */}
//         {step === 1 && (
//           <form onSubmit={handleRegister}>
//             <div className="form-group">
//               <label>Owner Name</label>
//               <input
//                 type="text"
//                 className="form-input"
//                 name="ownerName"
//                 value={formData.ownerName}
//                 onChange={handleInputChange}
//                 placeholder="e.g. Sonu Saini"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Business Trade Name</label>
//               <input
//                 type="text"
//                 className="form-input"
//                 name="businessName"
//                 value={formData.businessName}
//                 onChange={handleInputChange}
//                 placeholder="e.g. Royal Cafe & Lounge"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Business Classification Type</label>
//               <input
//                 type="text"
//                 className="form-input"
//                 name="businessType"
//                 value={formData.businessType}
//                 onChange={handleInputChange}
//                 placeholder="e.g. Restaurant, Grocery, Pharmacy"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Mobile Number</label>
//               <input
//                 type="tel"
//                 className="form-input"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={handleInputChange}
//                 placeholder="10-digit smartphone sequence"
//                 maxLength="10"
//                 pattern="[0-9]{10}"
//                 required
//               />
//             </div>

//             <div className="form-group">
//               <label>Physical Address Location</label>
//               <textarea
//                 className="form-input form-textarea"
//                 name="address"
//                 value={formData.address}
//                 onChange={handleInputChange}
//                 placeholder="e.g. Near Main Square, Bir Kalwa"
//                 required
//               />
//             </div>

//             <button type="submit" className="submit-btn-primary" disabled={loading}>
//               {loading ? <div className="spinner"></div> : "Request OTP Validation"}
//             </button>
//           </form>
//         )}

//         {/* SEQUENCE TERMINAL 2: INTERACTIVE OTP VALIDATOR */}
//         {step === 2 && (
//           <form onSubmit={handleVerifyOTP}>
//             <p className="context-alert-text">
//               Secure authentication handshake code transmitted to: <br />
//               <strong style={{ color: "#6366f1" }}>+91 {formData.mobile}</strong>
//             </p>

//             <div className="otp-box-wrapper">
//               <input
//                 type="text"
//                 className="otp-web-input"
//                 value={otpCode}
//                 onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, ""))}
//                 placeholder="••••"
//                 maxLength="4"
//                 required
//                 autoFocus
//               />
//             </div>

//             <button type="submit" className="submit-btn-primary" disabled={loading}>
//               {loading ? <div className="spinner"></div> : "Verify & Deploy Business Profile"}
//             </button>

//             <button
//               type="button"
//               className="back-nav-link"
//               onClick={() => setStep(1)}
//               disabled={loading}
//             >
//               ← Edit Profile Configuration Metrics
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// }



// import React, { useState, useRef } from "react";

// // Predefined merchant shop categories
// const BUSINESS_CATEGORIES = [
//   "Restaurant & Cafe",
//   "Grocery & Supermarket",
//   "Clothing & Apparel",
//   "Electronics & Gadgets",
//   "Medical & Pharmacy",
//   "Salon & Spa",
//   "Bakery & Confectionery",
//   "Other Retail Business"
// ];

// export default function MerchantAuthPremium() {
//   const [step, setStep] = useState(1); // 1 = Beautiful Form, 2 = Ultra Clean OTP Terminal
//   const [loading, setLoading] = useState(false);

//   // Registration states matching your target fields
//   const [formData, setFormData] = useState({
//     ownerName: "",
//     businessName: "",
//     businessType: "", // Linked directly to the Dropdown selector
//     mobile: "",
//     address: ""
//   });

//   // Array state for independent multi-box OTP entry tracking
//   const [otpArray, setOtpArray] = useState(["", "", "", ""]);
//   const otpRefs = [useRef(), useRef(), useRef(), useRef()];

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Modern handling logic for discrete 4-digit code fields entry grids
//   const handleOtpKeyIn = (index, value) => {
//     const cleanValue = value.replace(/\D/g, "");
//     const newOtp = [...otpArray];
//     newOtp[index] = cleanValue;
//     setOtpArray(newOtp);

//     // Dynamic focus shifting to subsequent blocks upon input entry strings auto matching
//     if (cleanValue && index < 3) {
//       otpRefs[index + 1].current.focus();
//     }
//   };

//   const handleOtpBackSpace = (index, e) => {
//     if (e.key === "Backspace" && !otpArray[index] && index > 0) {
//       otpRefs[index - 1].current.focus();
//     }
//   };

//   // STEP 1: INITIALIZE REGISTRATION POST VIA FORMDATA
//   const handleRegisterSubmit = async (e) => {
//     e.preventDefault();
//     const { ownerName, businessName, businessType, mobile, address } = formData;

//     if (!ownerName || !businessName || businessType === "" || !mobile || !address) {
//       alert("Please complete all profile details to continue.");
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = new FormData();
//       payload.append("owner_name", ownerName);
//       payload.append("business_name", businessName);
//       payload.append("business_type", businessType);
//       payload.append("mobile", mobile);
//       payload.append("address", address);

//       const requestOptions = {
//         method: "POST",
//         body: payload,
//         redirect: "follow"
//       };

//       const response = await fetch("https://countmyvisit.com/Apis/marchentlogin.php", requestOptions);
//       const resultText = await response.text();
//       console.log("Server Handshake Output Data:", resultText);

//       // Successfully processed parameters, progress view timeline pointer 
//       setStep(2);
//     } catch (error) {
//       console.error("Network Node Communication Interrupt:", error);
//       alert("Registration failed. Unable to securely broadcast account settings.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // STEP 2: FINALIZE VERIFY TRANSACTION SECURE HANDSHAKE
//   const handleVerifyOtpSubmit = async (e) => {
//     e.preventDefault();
//     const joinedOtp = otpArray.join("");

//     if (joinedOtp.length < 4) {
//       alert("Please fill up all security digits code cells.");
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = new FormData();
//       payload.append("mobile", formData.mobile);
//       payload.append("otp_code", joinedOtp);

//       const requestOptions = {
//         method: "POST",
//         body: payload,
//         redirect: "follow"
//       };

//       const response = await fetch("https://countmyvisit.com/Apis/verify_otp.php", requestOptions);
//       const resultText = await response.text();
//       console.log("Authorization Engine Traceback Logs:", resultText);

//       alert("Identity clear 🎉 Merchant node activated!");
      
//       // Cleanup environment state maps back into default values
//       setStep(1);
//       setOtpArray(["", "", "", ""]);
//       setFormData({ ownerName: "", businessName: "", businessType: "", mobile: "", address: "" });
//     } catch (error) {
//       console.error("Security Authentication Gateway fault:", error);
//       alert("Clearance verification rejected the submitted validation security parameters.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="premium-auth-container">
//       {/* SCOPED RAW CSS LAYOUT ENGINE */}
//       <style>{`
//         .premium-auth-container {
//           min-height: 100vh;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: linear-gradient(135deg, #eef2f6 0%, #dfe7f0 100%);
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           padding: 24px;
//           box-sizing: border-box;
//         }
//         .premium-card {
//           background: #ffffff;
//           width: 100%;
//           max-width: 500px;
//           border-radius: 24px;
//           border: 1px solid rgba(255, 255, 255, 0.7);
//           box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(0,0,0,0.02);
//           padding: 40px;
//           box-sizing: border-box;
//           position: relative;
//           overflow: hidden;
//         }
//         .premium-card::before {
//           content: '';
//           position: absolute;
//           top: 0; left: 0; right: 0;
//           height: 6px;
//           background: linear-gradient(90deg, #4f46e5 0%, #7c3aed 100%);
//         }
//         .header-section {
//           text-align: center;
//           margin-bottom: 36px;
//         }
//         .portal-title {
//           font-size: 28px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 0 0 8px 0;
//           letter-spacing: -0.75px;
//         }
//         .portal-subtitle {
//           font-size: 14px;
//           color: #64748b;
//           margin: 0;
//           font-weight: 500;
//         }
//         .input-block-group {
//           margin-bottom: 22px;
//           display: flex;
//           flex-direction: column;
//           gap: 6px;
//         }
//         .input-block-group label {
//           font-size: 12px;
//           font-weight: 700;
//           color: #475569;
//           text-transform: uppercase;
//           letter-spacing: 0.75px;
//         }
//         .control-element {
//           width: 100%;
//           padding: 14px 16px;
//           border-radius: 12px;
//           border: 1px solid #cbd5e1;
//           font-size: 15px;
//           color: #0f172a;
//           background: #f8fafc;
//           outline: none;
//           transition: all 0.25s ease;
//           box-sizing: border-box;
//         }
//         .control-element:focus {
//           border-color: #4f46e5;
//           background: #ffffff;
//           box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
//         }
//         select.control-element {
//           appearance: none;
//           background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23475569' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
//           background-repeat: no-repeat;
//           background-position: right 16px center;
//           background-size: 16px;
//           padding-right: 40px;
//           cursor: pointer;
//         }
//         .textarea-modifier {
//           resize: none;
//           min-height: 76px;
//           line-height: 22px;
//         }
//         .otp-grid-box {
//           display: flex;
//           justify-content: center;
//           gap: 14px;
//           margin: 32px 0;
//         }
//         .otp-cell-field {
//           width: 56px;
//           height: 60px;
//           font-size: 24px;
//           font-weight: 700;
//           text-align: center;
//           border: 2px solid #cbd5e1;
//           border-radius: 14px;
//           background: #f8fafc;
//           color: #0f172a;
//           outline: none;
//           transition: all 0.2s ease;
//         }
//         .otp-cell-field:focus {
//           border-color: #7c3aed;
//           background: #ffffff;
//           box-shadow: 0 0 0 4px rgba(124, 58, 237, 0.15);
//         }
//         .primary-action-trigger {
//           width: 100%;
//           background: "linear-gradient(135deg, #ff8c42, #ff5e62)"
//           {/* color: #ffffff; */}
//           border: none;
//           padding: 16px;
//           font-size: 15px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: transform 0.1s ease, opacity 0.2s;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//           box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
//         }
//         .primary-action-trigger:hover {
//           opacity: 0.95;
//         }
//         .primary-action-trigger:active {
//           transform: scale(0.99);
//         }
//         .primary-action-trigger:disabled {
//           background: #94a3b8;
//           box-shadow: none;
//           cursor: not-allowed;
//         }
//         .fallback-step-trigger {
//           display: block;
//           text-align: center;
//           margin-top: 24px;
//           font-size: 13px;
//           color: #64748b;
//           background: none;
//           border: none;
//           width: 100%;
//           cursor: pointer;
//           font-weight: 600;
//           transition: color 0.2s;
//         }
//         .fallback-step-trigger:hover {
//           color: #4f46e5;
//         }
//         .notification-info-card {
//           font-size: 14px;
//           color: #475569;
//           text-align: center;
//           line-height: 22px;
//           margin-bottom: 8px;
//         }
//         .loader-ring {
//           width: 20px;
//           height: 20px;
//           border: 2.5px solid rgba(255,255,255,0.3);
//           border-top-color: #ffffff;
//           border-radius: 50%;
//           animation: spinAnimation 0.65s linear infinite;
//         }
//         @keyframes spinAnimation {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div className="premium-card">
//         {/* TOP LAYER CONTENT HEADERS */}
//         <div className="header-section">
//           <h1 className="portal-title">Count My Visit</h1>
//           <p className="portal-subtitle">
//             {step === 1 ? "Partner Merchant Workspace Onboarding" : "Identity Verification Gate"}
//           </p>
//         </div>

//         {/* SCREEN FLOW 1: INTERACTIVE ENHANCED APPLICATION REGISTRATION */}
//         {step === 1 && (
//           <form onSubmit={handleRegisterSubmit}>
//             <div className="input-block-group">
//               <label>Owner Name</label>
//               <input
//                 type="text"
//                 className="control-element"
//                 name="ownerName"
//                 value={formData.ownerName}
//                 onChange={handleInputChange}
//                 placeholder="Enter full legal identity name"
//                 required
//               />
//             </div>

//             <div className="input-block-group">
//               <label>Business Entity Trade Name</label>
//               <input
//                 type="text"
//                 className="control-element"
//                 name="businessName"
//                 value={formData.businessName}
//                 onChange={handleInputChange}
//                 placeholder="e.g. Royal Cafe & Lounge"
//                 required
//               />
//             </div>

//             {/* NEW ADDITION: ENHANCED HIGHLY VISUAL CATEGORY SELECTION LIST */}
//             <div className="input-block-group">
//               <label>Business Classification Category</label>
//               <select
//                 className="control-element"
//                 name="businessType"
//                 value={formData.businessType}
//                 onChange={handleInputChange}
//                 required
//               >
//                 <option value="" disabled hidden>-- Select Shop Category --</option>
//                 {BUSINESS_CATEGORIES.map((category, index) => (
//                   <option key={index} value={category}>{category}</option>
//                 ))}
//               </select>
//             </div>

//             <div className="input-block-group">
//               <label>Primary Mobile Line</label>
//               <input
//                 type="tel"
//                 className="control-element"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={handleInputChange}
//                 placeholder="10-digit smartphone line connection"
//                 maxLength="10"
//                 pattern="[0-9]{10}"
//                 required
//               />
//             </div>

//             <div className="input-block-group">
//               <label>Operational Geographic Address</label>
//               <textarea
//                 className="control-element textarea-modifier"
//                 name="address"
//                 value={formData.address}
//                 onChange={handleInputChange}
//                 placeholder="Complete street block details, town, state..."
//                 required
//               />
//             </div>

//             <button type="submit" className="primary-action-trigger" disabled={loading}>
//               {loading ? <div className="loader-ring"></div> : "Deploy Verification Token"}
//             </button>
//           </form>
//         )}

//         {/* SCREEN FLOW 2: PREMIUM INDEPENDENT GRID INTERACTIVE OTP CODE TERMINAL */}
//         {step === 2 && (
//           <form onSubmit={handleVerifyOtpSubmit}>
//             <p className="notification-info-card">
//               Security verification token code successfully transmitted directly to destination route line: <br />
//               <strong style={{ color: "#4f46e5", fontSize: "15px" }}>+91 {formData.mobile}</strong>
//             </p>

//             <div className="otp-grid-box">
//               {otpArray.map((digit, index) => (
//                 <input
//                   key={index}
//                   ref={otpRefs[index]}
//                   type="text"
//                   className="otp-cell-field"
//                   value={digit}
//                   maxLength="1"
//                   onChange={(e) => handleOtpKeyIn(index, e.target.value)}
//                   onKeyDown={(e) => handleOtpBackSpace(index, e)}
//                   placeholder="•"
//                   required
//                 />
//               ))}
//             </div>

//             <button type="submit" className="primary-action-trigger" disabled={loading}>
//               {loading ? <div className="loader-ring"></div> : "Authorize Core Configuration Code"}
//             </button>

//             <button
//               type="button"
//               className="fallback-step-trigger"
//               onClick={() => setStep(1)}
//               disabled={loading}
//             >
//               ← Modify Business Parameters Metrics
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// }


// import React, { useState, useRef } from "react";

// // Predefined merchant shop categories
// const BUSINESS_CATEGORIES = [
//   "Restaurant & Cafe",
//   "Grocery & Supermarket",
//   "Clothing & Apparel",
//   "Electronics & Gadgets",
//   "Medical & Pharmacy",
//   "Salon & Spa",
//   "Bakery & Confectionery",
//   "Other Retail Business"
// ];

// export default function MerchantAuthPremium() {
//   const [authMode, setAuthMode] = useState("signup"); // "signup" or "login"
//   const [step, setStep] = useState(1); // 1 = Input Fields Form, 2 = OTP Terminal
//   const [loading, setLoading] = useState(false);

//   // Registration states matching your target fields
//   const [formData, setFormData] = useState({
//     ownerName: "",
//     businessName: "",
//     businessType: "", 
//     mobile: "",
//     address: ""
//   });

//   // Array state for independent multi-box OTP entry tracking
//   const [otpArray, setOtpArray] = useState([ "", "", "", "", "", ""]);
//   const otpRefs = [useRef(), useRef(), useRef(), useRef()];

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Switch between login and signup smoothly
//   const handleModeChange = (mode) => {
//     setAuthMode(mode);
//     setStep(1); // Reset back to step 1 input phase
//   };

//   // Modern handling logic for discrete 4-digit code fields entry grids
//   const handleOtpKeyIn = (index, value) => {
//     const cleanValue = value.replace(/\D/g, "");
//     const newOtp = [...otpArray];
//     newOtp[index] = cleanValue;
//     setOtpArray(newOtp);

//     // Dynamic focus shifting to subsequent blocks upon input entry strings auto matching
//     if (cleanValue && index < 3) {
//       otpRefs[index + 1].current.focus();
//     }
//   };

//   const handleOtpBackSpace = (index, e) => {
//     if (e.key === "Backspace" && !otpArray[index] && index > 0) {
//       otpRefs[index - 1].current.focus();
//     }
//   };

//   // STEP 1: INITIALIZE REGISTRATION OR LOGIN POST VIA FORMDATA
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (authMode === "signup") {
//       const { ownerName, businessName, businessType, mobile, address } = formData;
//       if (!ownerName || !businessName || businessType === "" || !mobile || !address) {
//         alert("Please complete all profile details to continue.");
//         return;
//       }
//     } else {
//       if (!formData.mobile) {
//         alert("Please enter your mobile number.");
//         return;
//       }
//     }

//     setLoading(true);

//     try {
//       const payload = new FormData();
//       payload.append("mobile", formData.mobile);

//       if (authMode === "signup") {
//         payload.append("owner_name", formData.ownerName);
//         payload.append("business_name", formData.businessName);
//         payload.append("business_type", formData.businessType);
//         payload.append("address", formData.address);
//       }

//       const requestOptions = {
//         method: "POST",
//         body: payload,
//         redirect: "follow"
//       };

//       // Directing to your merchant auth script endpoint
//       const endpoint = "https://countmyvisit.com/Apis/marchentlogin.php";
//       const response = await fetch(endpoint, requestOptions);
//       const resultText = await response.text();
//       console.log("Server Handshake Output Data:", resultText);

//       // Transition forward to OTP stage
//       setStep(2);
//     } catch (error) {
//       console.error("Network Node Communication Interrupt:", error);
//       alert(`${authMode === "signup" ? "Registration" : "Login"} request failed. Unable to communicate with server.`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // STEP 2: FINALIZE VERIFY TRANSACTION SECURE HANDSHAKE
//   const handleVerifyOtpSubmit = async (e) => {
//     e.preventDefault();
//     const joinedOtp = otpArray.join("");

//     if (joinedOtp.length < 4) {
//       alert("Please fill up all security digits code cells.");
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = new FormData();
//       payload.append("mobile", formData.mobile);
//       payload.append("otp_code", joinedOtp);

//       const requestOptions = {
//         method: "POST",
//         body: payload,
//         redirect: "follow"
//       };

//       const response = await fetch("https://countmyvisit.com/Apis/verify_otp.php", requestOptions);
//       const resultText = await response.text();
//       console.log("Authorization Engine Traceback Logs:", resultText);

//       alert(`Identity clear 🎉 Merchant session validated successfully!`);
      
//       // Reset state metrics
//       setStep(1);
//       setOtpArray(["", "", "", "", "", ""]);
//       setFormData({ ownerName: "", businessName: "", businessType: "", mobile: "", address: "" });
//     } catch (error) {
//       console.error("Security Authentication Gateway fault:", error);
//       alert("Clearance verification rejected the submitted validation security parameters.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="premium-auth-container">
//       {/* SCOPED MODERN CSS LAYOUT ENGINE */}
//       <style>{`
//         .premium-auth-container {
//           min-height: 100vh;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: linear-gradient(135deg, #eef2f6 0%, #dfe7f0 100%);
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           padding: 24px;
//           box-sizing: border-box;
//         }
//         .premium-card {
//           background: #ffffff;
//           width: 100%;
//           max-width: 500px;
//           border-radius: 24px;
//           border: 1px solid rgba(255, 255, 255, 0.7);
//           box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(0,0,0,0.02);
//           padding: 40px;
//           box-sizing: border-box;
//           position: relative;
//           overflow: hidden;
//         }
//         .premium-card::before {
//           content: '';
//           position: absolute;
//           top: 0; left: 0; right: 0;
//           height: 6px;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//         }
//         .header-section {
//           text-align: center;
//           margin-bottom: 24px;
//         }
//         .portal-title {
//           font-size: 28px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 0 0 8px 0;
//           letter-spacing: -0.75px;
//         }
//         .portal-subtitle {
//           font-size: 14px;
//           color: #64748b;
//           margin: 0;
//           font-weight: 500;
//         }
        
//         /* Modern mode selection tabs style */
//         .auth-mode-tabs {
//           display: flex;
//           background: #f1f5f9;
//           padding: 4px;
//           border-radius: 12px;
//           margin-bottom: 30px;
//         }
//         .mode-tab-btn {
//           flex: 1;
//           background: none;
//           border: none;
//           padding: 10px;
//           font-size: 14px;
//           font-weight: 600;
//           color: #64748b;
//           cursor: pointer;
//           border-radius: 8px;
//           transition: all 0.2s ease;
//         }
//         .mode-tab-btn.active {
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           color: #ffffff;
//           box-shadow: 0 4px 10px rgba(255, 94, 98, 0.2);
//         }

//         .input-block-group {
//           margin-bottom: 22px;
//           display: flex;
//           flex-direction: column;
//           gap: 6px;
//         }
//         .input-block-group label {
//           font-size: 12px;
//           font-weight: 700;
//           color: #475569;
//           text-transform: uppercase;
//           letter-spacing: 0.75px;
//         }
//         .control-element {
//           width: 100%;
//           padding: 14px 16px;
//           border-radius: 12px;
//           border: 1px solid #cbd5e1;
//           font-size: 15px;
//           color: #0f172a;
//           background: #f8fafc;
//           outline: none;
//           transition: all 0.25s ease;
//           box-sizing: border-box;
//         }
//         .control-element:focus {
//           border-color: #ff8c42;
//           background: #ffffff;
//           box-shadow: 0 0 0 4px rgba(255, 140, 66, 0.15);
//         }
//         select.control-element {
//           appearance: none;
//           background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23475569' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
//           background-repeat: no-repeat;
//           background-position: right 16px center;
//           background-size: 16px;
//           padding-right: 40px;
//           cursor: pointer;
//         }
//         .textarea-modifier {
//           resize: none;
//           min-height: 76px;
//           line-height: 22px;
//         }
//         .otp-grid-box {
//           display: flex;
//           justify-content: center;
//           gap: 14px;
//           margin: 32px 0;
//         }
//         .otp-cell-field {
//           width: 56px;
//           height: 60px;
//           font-size: 24px;
//           font-weight: 700;
//           text-align: center;
//           border: 2px solid #cbd5e1;
//           border-radius: 14px;
//           background: #f8fafc;
//           color: #0f172a;
//           outline: none;
//           transition: all 0.2s ease;
//         }
//         .otp-cell-field:focus {
//           border-color: #ff5e62;
//           background: #ffffff;
//           box-shadow: 0 0 0 4px rgba(255, 94, 98, 0.2);
//         }
//         .primary-action-trigger {
//           width: 100%;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           color: #ffffff;
//           border: none;
//           padding: 16px;
//           font-size: 15px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: transform 0.1s ease, opacity 0.2s;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//           box-shadow: 0 4px 14px rgba(255, 94, 98, 0.3);
//         }
//         .primary-action-trigger:hover {
//           opacity: 0.95;
//         }
//         .primary-action-trigger:active {
//           transform: scale(0.99);
//         }
//         .primary-action-trigger:disabled {
//           background: #94a3b8;
//           box-shadow: none;
//           cursor: not-allowed;
//         }
//         .fallback-step-trigger {
//           display: block;
//           text-align: center;
//           margin-top: 24px;
//           font-size: 13px;
//           color: #64748b;
//           background: none;
//           border: none;
//           width: 100%;
//           cursor: pointer;
//           font-weight: 600;
//           transition: color 0.2s;
//         }
//         .fallback-step-trigger:hover {
//           color: #ff5e62;
//         }
//         .notification-info-card {
//           font-size: 14px;
//           color: #475569;
//           text-align: center;
//           line-height: 22px;
//           margin-bottom: 8px;
//         }
//         .loader-ring {
//           width: 20px;
//           height: 20px;
//           border: 2.5px solid rgba(255,255,255,0.3);
//           border-top-color: #ffffff;
//           border-radius: 50%;
//           animation: spinAnimation 0.65s linear infinite;
//         }
//         @keyframes spinAnimation {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div className="premium-card">
//         {/* TOP LAYER CONTENT HEADERS */}
//         <div className="header-section">
//           <h1 className="portal-title">Count My Visit it is used by contact number alkso</h1>
//           <p className="portal-subtitle">
//             {step === 1 ? "Partner Merchant Workspace Console" : "Identity Verification Gate"}
//           </p>
//         </div>

//         {/* INTERACTIVE TOGGLE: SIGNUP / LOGIN (Only visible during state choice entry phase) */}
//         {step === 1 && (
//           <div className="auth-mode-tabs">
//             <button 
//               type="button"
//               className={`mode-tab-btn ${authMode === "signup" ? "active" : ""}`}
//               onClick={() => handleModeChange("signup")}
//             >
//               Merchant Sign Up
//             </button>
//             <button 
//               type="button"
//               className={`mode-tab-btn ${authMode === "login" ? "active" : ""}`}
//               onClick={() => handleModeChange("login")}
//             >
//               Merchant Login
//             </button>
//           </div>
//         )}

//         {/* SCREEN FLOW 1: DYNAMIC FORM TERMINAL */}
//         {step === 1 && (
//           <form onSubmit={handleFormSubmit}>
            
//             {/* Conditional Input Rendering for fields based on Selected Sign-up Flow */}
//             {authMode === "signup" && (
//               <>
//                 <div className="input-block-group">
//                   <label>Owner Name</label>
//                   <input
//                     type="text"
//                     className="control-element"
//                     name="ownerName"
//                     value={formData.ownerName}
//                     onChange={handleInputChange}
//                     placeholder="Enter full legal identity name"
//                     required
//                   />
//                 </div>

//                 <div className="input-block-group">
//                   <label>Business Entity Trade Name</label>
//                   <input
//                     type="text"
//                     className="control-element"
//                     name="businessName"
//                     value={formData.businessName}
//                     onChange={handleInputChange}
//                     placeholder="e.g. Royal Cafe & Lounge"
//                     required
//                   />
//                 </div>

//                 <div className="input-block-group">
//                   <label>Business Classification Category</label>
//                   <select
//                     className="control-element"
//                     name="businessType"
//                     value={formData.businessType}
//                     onChange={handleInputChange}
//                     required
//                   >
//                     <option value="" disabled hidden>-- Select Shop Category --</option>
//                     {BUSINESS_CATEGORIES.map((category, index) => (
//                       <option key={index} value={category}>{category}</option>
//                     ))}
//                   </select>
//                 </div>
//               </>
//             )}

//             {/* SHARED MOBILE NUMBER FIELD (Always active for both Signup and Login) */}
//             <div className="input-block-group">
//               <label>Primary Mobile Line</label>
//               <input
//                 type="tel"
//                 className="control-element"
//                 name="mobile"
//                 value={formData.mobile}
//                 onChange={handleInputChange}
//                 placeholder="10-digit mobile number"
//                 maxLength="10"
//                 pattern="[0-9]{10}"
//                 required
//               />
//             </div>

//             {/* Conditional Address Area for Signup Context */}
//             {authMode === "signup" && (
//               <div className="input-block-group">
//                 <label>Operational Geographic Address</label>
//                 <textarea
//                   className="control-element textarea-modifier"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   placeholder="Complete street block details, town, state..."
//                   required
//                 />
//               </div>
//             )}

//             <button type="submit" className="primary-action-trigger" disabled={loading}>
//               {loading ? <div className="loader-ring"></div> : "Deploy Verification Token"}
//             </button>
//           </form>
//         )}

//         {/* SCREEN FLOW 2: INDEPENDENT GRID INTERACTIVE OTP CODE TERMINAL */}
//         {step === 2 && (
//           <form onSubmit={handleVerifyOtpSubmit}>
//             <p className="notification-info-card">
//               Security verification token code successfully transmitted directly to destination route line: <br />
//               <strong style={{ color: "#ff5e62", fontSize: "15px" }}>+91 {formData.mobile}</strong>
//             </p>

//             <div className="otp-grid-box">
//               {otpArray.map((digit, index) => (
//                 <input
//                   key={index}
//                   ref={otpRefs[index]}
//                   type="text"
//                   className="otp-cell-field"
//                   value={digit}
//                   maxLength="1"
//                   onChange={(e) => handleOtpKeyIn(index, e.target.value)}
//                   onKeyDown={(e) => handleOtpBackSpace(index, e)}
//                   placeholder="•"
//                   required
//                 />
//               ))}
//             </div>

//             <button type="submit" className="primary-action-trigger" disabled={loading}>
//               {loading ? <div className="loader-ring"></div> : "Authorize Core Configuration Code"}
//             </button>

//             <button
//               type="button"
//               className="fallback-step-trigger"
//               onClick={() => setStep(1)}
//               disabled={loading}
//             >
//               ← Modify Operational Matrix Parameters
//             </button>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// export default function MerchantLogin() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
// const navigate = useNavigate();
//   const handleLoginSubmit = async (e) => {
//     e.preventDefault();
//     if (!username || !password) {
//       alert("Please enter both username and password.");
//       return;
//     }

//     setLoading(true);

//     try {
//       // Form Data setup as per your API requirement
//       const formdata = new FormData();
//       formdata.append("username", username);
//       formdata.append("password", password);

//       const requestOptions = {
//         method: "POST",
//         body: formdata,
//         redirect: "follow"
//       };

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_login.php", requestOptions);
//       const resultText = await response.text();
      
//       console.log("Raw Response:", resultText);

//       // Cleaning the response if it includes "DATABASE CONNECTED" text before JSON
//       const cleanJsonString = resultText.replace("DATABASE CONNECTED", "").trim();
//       const jsonData = JSON.parse(cleanJsonString);

//       if (jsonData.success) {
//         // Saving response to localStorage as you requested
//         localStorage.setItem("marchentdata", JSON.stringify(jsonData));
        
//         // Changing state to show the success screen
//         setIsLoggedIn(true);
//       } else {
//         alert(jsonData.message || "Login failed. Please check your credentials.");
//       }
//     } catch (error) {
//       console.error("Login Error:", error);
//       alert("Something went wrong. Please check your internet or API.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // --- NEXT SCREEN / SUCCESS VIEW ---
//   if (isLoggedIn) {
//     const savedData = JSON.parse(localStorage.getItem("marchentdata"));
//     const merchant = savedData?.merchant || {};

//     return (
//       <div className="premium-auth-container">
//         <style>{`
//           .premium-auth-container {
//             min-height: 100vh;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             background: linear-gradient(135deg, #f1f5f9 0%, #cbd5e1 100%);
//             font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//             padding: 24px;
//             box-sizing: border-box;
//           }
//           .success-card {
//             background: #ffffff;
//             width: 100%;
//             max-width: 480px;
//             border-radius: 24px;
//             box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.1);
//             padding: 40px;
//             box-sizing: border-box;
//             text-align: center;
//             border-top: 6px solid #10b981;
//           }
//           .success-icon {
//             font-size: 50px;
//             margin-bottom: 16px;
//           }
//           .welcome-title {
//             font-size: 24px;
//             font-weight: 800;
//             color: #0f172a;
//             margin: 0 0 8px 0;
//           }
//           .welcome-subtitle {
//             font-size: 14px;
//             color: #64748b;
//             margin-bottom: 24px;
//           }
//           .info-list {
//             text-align: left;
//             background: #f8fafc;
//             border-radius: 16px;
//             padding: 20px;
//             margin-bottom: 24px;
//             border: 1px solid #e2e8f0;
//           }
//           .info-item {
//             display: flex;
//             justify-content: space-between;
//             padding: 8px 0;
//             border-bottom: 1px solid #edf2f7;
//             font-size: 14px;
//           }
//           .info-item:last-child {
//             border-bottom: none;
//           }
//           .info-label {
//             color: #64748b;
//             font-weight: 500;
//           }
//           .info-value {
//             color: #0f172a;
//             font-weight: 600;
//           }
//           .logout-btn {
//             background: #ef4444;
//             color: white;
//             border: none;
//             padding: 12px 24px;
//             border-radius: 12px;
//             font-weight: 600;
//             cursor: pointer;
//             transition: opacity 0.2s;
//           }
//           .logout-btn:hover { opacity: 0.9; }
//         `}</style>

//         <div className="success-card">
//           <div className="success-icon">🎉</div>
//           <h1 className="welcome-title">Welcome Back!</h1>
//           <p className="welcome-subtitle">You have successfully logged into your workspace.</p>
          
//           <div className="info-list">
//             <div className="info-item">
//               <span className="info-label">Owner Name:</span>
//               <span className="info-value">{merchant.owner_name}</span>
//             </div>
//             <div className="info-item">
//               <span className="info-label">Business Name:</span>
//               <span className="info-value">{merchant.business_name}</span>
//             </div>
//             <div className="info-item">
//               <span className="info-label">Business Type:</span>
//               <span className="info-value">{merchant.business_type}</span>
//             </div>
//             <div className="info-item">
//               <span className="info-label">Mobile:</span>
//               <span className="info-value">{merchant.mobile}</span>
//             </div>
//             <div className="info-item">
//               <span className="info-label">Status:</span>
//               <span className="info-value" style={{ color: '#10b981' }}>{merchant.status?.toUpperCase()}</span>
//             </div>
//           </div>

//           <button className="logout-btn" onClick={() => {
//             localStorage.removeItem("marchentdata");
//             setIsLoggedIn(false);
//           }}>
//             Logout
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // --- LOGIN FORM SCREEN ---
//   return (
//     <div className="premium-auth-container">
//       <style>{`
//         .premium-auth-container {
//           min-height: 100vh;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: linear-gradient(135deg, #eef2f6 0%, #dfe7f0 100%);
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
//           padding: 24px;
//           box-sizing: border-box;
//         }
//         .premium-card {
//           background: #ffffff;
//           width: 100%;
//           max-width: 420px;
//           border-radius: 24px;
//           box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.08);
//           padding: 40px;
//           box-sizing: border-box;
//           position: relative;
//           overflow: hidden;
//         }
//         .premium-card::before {
//           content: '';
//           position: absolute;
//           top: 0; left: 0; right: 0;
//           height: 6px;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//         }
//         .header-section {
//           text-align: center;
//           margin-bottom: 32px;
//         }
//         .portal-title {
//           font-size: 26px;
//           font-weight: 800;
//           color: #0f172a;
//           margin: 0 0 8px 0;
//           letter-spacing: -0.5px;
//         }
//         .portal-subtitle {
//           font-size: 14px;
//           color: #64748b;
//           margin: 0;
//           font-weight: 500;
//         }
//         .input-block-group {
//           margin-bottom: 20px;
//           display: flex;
//           flex-direction: column;
//           gap: 6px;
//         }
//         .input-block-group label {
//           font-size: 11px;
//           font-weight: 700;
//           color: #475569;
//           text-transform: uppercase;
//           letter-spacing: 0.75px;
//         }
//         .control-element {
//           width: 100%;
//           padding: 14px 16px;
//           border-radius: 12px;
//           border: 1px solid #cbd5e1;
//           font-size: 15px;
//           color: #0f172a;
//           background: #f8fafc;
//           outline: none;
//           transition: all 0.25s ease;
//           box-sizing: border-box;
//         }
//         .control-element:focus {
//           border-color: #ff8c42;
//           background: #ffffff;
//           box-shadow: 0 0 0 4px rgba(255, 140, 66, 0.15);
//         }
//         .primary-action-trigger {
//           width: 100%;
//           background: linear-gradient(135deg, #ff8c42, #ff5e62);
//           color: #ffffff;
//           border: none;
//           padding: 16px;
//           font-size: 15px;
//           font-weight: 600;
//           border-radius: 12px;
//           cursor: pointer;
//           transition: transform 0.1s ease, opacity 0.2s;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//           box-shadow: 0 4px 14px rgba(255, 94, 98, 0.3);
//           margin-top: 26px;
//         }
//         .primary-action-trigger:hover { opacity: 0.95; }
//         .primary-action-trigger:active { transform: scale(0.99); }
//         .primary-action-trigger:disabled {
//           background: #94a3b8;
//           box-shadow: none;
//           cursor: not-allowed;
//         }
//         .loader-ring {
//           width: 20px;
//           height: 20px;
//           border: 2.5px solid rgba(255,255,255,0.3);
//           border-top-color: #ffffff;
//           border-radius: 50%;
//           animation: spinAnimation 0.65s linear infinite;
//         }
//         @keyframes spinAnimation {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div className="premium-card">
//         <div className="header-section">
//           <h1 className="portal-title">Count My Visit</h1>
//           <p className="portal-subtitle">Merchant Login Workspace</p>
//         </div>

//         <form onSubmit={handleLoginSubmit}>
//           <div className="input-block-group">
//             <label>Username / Cafe Name</label>
//             <input
//               type="text"
//               className="control-element"
//               value={username}
//               onChange={(e) => setUsername(e.target.value)}
//               placeholder="Enter your username"
//               required
//             />
//           </div>

//           <div className="input-block-group">
//             <label>Password</label>
//             <input
//               type="password"
//               className="control-element"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="••••••••"
//               required
//             />
//           </div>

//           <button type="submit" className="primary-action-trigger" disabled={loading}>
//             {loading ? <div className="loader-ring"></div> : "Secure Login"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

import React, { useState,useEffect } from "react";
// 1. React Router Dom se useNavigate import karein
import { useNavigate } from "react-router-dom"; 

export default function MerchantLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  
  // 2. Hook ko initialize karein
  const navigate = useNavigate(); 
// useEffect(() => {
//   const isLoggedIn = localStorage.getItem("isLoggedIn");
// console.log('here is console',isLoggedIn)
//   if (isLoggedIn === "true") {
//     navigate("/merchantrules");
//   }
// }, [navigate]);
 useEffect(() => {
    try {
      const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
      const userData = localStorage.getItem("userData");
      if (isLoggedIn && userData) {
        navigate("/merchantrules", { replace: true });
      }
    } catch (err) {
      // Storage unavailable (e.g. private mode): show the login form
    }
  }, [navigate]);
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert("Please enter both username and password.");
      return;
    }

    setLoading(true);

    try {
      const formdata = new FormData();
      formdata.append("username", username);
      formdata.append("password", password);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };

      const response = await fetch("https://countmyvisit.com/Apis/merchant_login.php", requestOptions);
      const resultText = await response.text();
      
      console.log("Raw Response:", resultText);

      // Cleaning "DATABASE CONNECTED" text before parsing JSON
      const cleanJsonString = resultText.replace("DATABASE CONNECTED", "").trim();
      const jsonData = JSON.parse(cleanJsonString);

    if (jsonData.success) {
  // Complete response save
  localStorage.setItem("marchentdata", JSON.stringify(jsonData));

  // Login Status
  localStorage.setItem("isLoggedIn", "true");

  navigate("/merchantrules");
} else {
        alert(jsonData.message || "Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Something went wrong. Please check your internet or API.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="premium-auth-container">
      <style>{`
        .premium-auth-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #eef2f6 0%, #dfe7f0 100%);
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          padding: 24px;
          box-sizing: border-box;
        }
        .premium-card {
          background: #ffffff;
          width: 100%;
          max-width: 420px;
          border-radius: 24px;
          box-shadow: 0 20px 40px -15px rgba(15, 23, 42, 0.08);
          padding: 40px;
          box-sizing: border-box;
          position: relative;
          overflow: hidden;
        }
        .premium-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 6px;
          background: linear-gradient(135deg, #ff8c42, #ff5e62);
        }
        .header-section {
          text-align: center;
          margin-bottom: 32px;
        }
        .portal-title {
          font-size: 26px;
          font-weight: 800;
          color: #0f172a;
          margin: 0 0 8px 0;
          letter-spacing: -0.5px;
        }
        .portal-subtitle {
          font-size: 14px;
          color: #64748b;
          margin: 0;
          font-weight: 500;
        }
        .input-block-group {
          margin-bottom: 20px;
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .input-block-group label {
          font-size: 11px;
          font-weight: 700;
          color: #475569;
          text-transform: uppercase;
          letter-spacing: 0.75px;
        }
        .control-element {
          width: 100%;
          padding: 14px 16px;
          border-radius: 12px;
          border: 1px solid #cbd5e1;
          font-size: 15px;
          color: #0f172a;
          background: #f8fafc;
          outline: none;
          transition: all 0.25s ease;
          box-sizing: border-box;
        }
        .control-element:focus {
          border-color: #ff8c42;
          background: #ffffff;
          box-shadow: 0 0 0 4px rgba(255, 140, 66, 0.15);
        }
        .primary-action-trigger {
          width: 100%;
          background: linear-gradient(135deg, #ff8c42, #ff5e62);
          color: #ffffff;
          border: none;
          padding: 16px;
          font-size: 15px;
          font-weight: 600;
          border-radius: 12px;
          cursor: pointer;
          transition: transform 0.1s ease, opacity 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          box-shadow: 0 4px 14px rgba(255, 94, 98, 0.3);
          margin-top: 26px;
        }
        .primary-action-trigger:hover { opacity: 0.95; }
        .primary-action-trigger:active { transform: scale(0.99); }
        .primary-action-trigger:disabled {
          background: #94a3b8;
          box-shadow: none;
          cursor: not-allowed;
        }
        .loader-ring {
          width: 20px;
          height: 20px;
          border: 2.5px solid rgba(255,255,255,0.3);
          border-top-color: #ffffff;
          border-radius: 50%;
          animation: spinAnimation 0.65s linear infinite;
        }
        @keyframes spinAnimation {
          to { transform: rotate(360deg); }
        }
      `}</style>

      <div className="premium-card">
        <div className="header-section">
          <h1 className="portal-title">Count My Visit</h1>
          <p className="portal-subtitle">Merchant Login Workspace</p>
        </div>

        <form onSubmit={handleLoginSubmit}>
          <div className="input-block-group">
            <label>Username / Cafe Name</label>
            <input
              type="text"
              className="control-element"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </div>

          <div className="input-block-group">
            <label>Password</label>
            <input
              type="password"
              className="control-element"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" className="primary-action-trigger" disabled={loading}>
            {loading ? <div className="loader-ring"></div> : "Secure Login"}
          </button>
        </form>
      </div>
    </div>
  );
}